import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_102: DocMigration = {
  maxSchemaVersion: "0.0.102",
  description: "All electrical layout rules require unique ids",
  apply(json: any) {
    const uniqueRuleIds: { [id: string]: boolean } = {};

    // roof settings
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "ELECTRICAL_SETTINGS") {
        continue;
      }

      if (!settings.rules) {
        continue;
      }

      for (const rule of settings.rules) {
        if (uniqueRuleIds[rule.id]) {
          rule.id = uid();
        } else {
          uniqueRuleIds[rule.id] = true;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_102;
